import { TableColumn } from '@silverfort/sf-components';
import { LogsTableRow } from './types';
import { DateCell, TypeCell, HeadlineCell } from './cells';

export const LOGS_TABLE_COLUMNS: TableColumn<LogsTableRow>[] = [
    {
        columnKey: 'date',
        title: 'Time',
        render: DateCell,
        columnClassName: 'min-w-[140px] max-w-[140px] !group-hover:text-[#333333]'
    },

    {
        columnKey: 'headline',
        title: 'Log',
        render: HeadlineCell,
        columnClassName: 'min-w-[416px] max-w-[416px] !cursor-default'
    },
    {
        columnKey: 'type',
        title: 'Type',
        render: TypeCell,
        columnClassName: 'min-w-[140px] max-w-[140px] !cursor-default'
    }
];
